<template>
  <div class="header">
    <!-- 手机端 侧边栏按钮 -->
    <span v-if="pc_app=='app' "><i class="el-icon-s-unfold app_sidebar_btn" @click="open_sidebar"></i></span>

    <div class="top_tit">
      <span v-if="kyc_icon_ok" class="back_icon"><i @click="$router.push('/user_info')" class="el-icon-back"></i></span>
      <span v-if="kyc_step_btn" class="back_icon"><i @click="$router.push('/kyc')" class="el-icon-back"></i></span>
      <span v-if="return_sup" class="back_icon"><i @click="$router.go(-1)" class="el-icon-back"></i></span>
      <span v-if="apply_card_info_return" class="back_icon"><i @click="info_return" class="el-icon-back"></i></span>
      <span class="head_width">{{head_title}}</span>
      <span class="head_title2">{{head_title2}}</span>
    </div>

    <div class="top_right_box">
      <div class="affiche_btn">
        <el-badge is-dot :hidden="dot_hidden">
          <i class="el-icon-message-solid" @click="to_affiche"></i>
        </el-badge>
      </div>
      <div class="top_right_box1">
        <!-- 语言切换 -->
        <el-popover
            placement="bottom"
            popper-class="top_user lan_popover"
            width="70"
            v-model="visible_lan"
            trigger="click">
          <span slot="reference">
            <span class="lan_icon" v-if="v_lan=='ch' ">简体中文</span>
            <span class="lan_icon" v-else-if="v_lan=='jp' ">日本語</span>
            <span class="lan_icon" v-else>English</span>
            <i v-if="visible_lan" class="el-icon-caret-top u_r_icon2"></i>
            <i v-else class="el-icon-caret-bottom u_r_icon2"></i>
          </span>
          <div class="u_box">
            <div class="lan_list_item" @click="lang_fun('ch')">简体中文</div>
            <div class="lan_list_item" @click="lang_fun('en')">English</div>
            <div class="lan_list_item" @click="lang_fun('jp')">日本語</div>
          </div>
        </el-popover>
      </div>
    
  </div>
    <!-- 退出登录 -->
    <el-dialog
        :visible.sync="log_out_dlg"
        custom-class="log_out_dlg_bgc"
        append-to-body
        center
        :show-close="false"
        width="480px">
        <!-- <div class="log_out1">
            <img src="../../assets/img/log_out_icon.png" alt="">
        </div> -->
        <div class="log_out2">
          {{$t('main.text5')}}
        </div>
        <div class="log_out3">
          {{$t('main.text6')}}
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="log_out_dlg = false" class="cancel_btn">{{$t('main.text7')}}</el-button>
            <el-button type="primary" class="confirm_btn" @click="log_out_btn">{{$t('main.text8')}}</el-button>
        </span>
    </el-dialog>

    <!-- 协议 -->
    <el-dialog
      :title="$t('beth_text.Cardholder_Agreement')"
      :visible.sync="protocol_status_dlg"
      custom-class="dlg element_input add_dlg"
      append-to-body
      center
      :show-close="protocol_status==1?false:true"
      :close-on-click-modal="protocol_status==1?false:true"
      :close-on-press-escape="protocol_status==1?false:true"
      width="850px"
    >
      <div class="dlg_body">
        <div class="dlg_agreement" @scroll="scroll">
          <p>This Cardholder agreement including any changes to it (the “Agreement”) contains the terms of your agreement with issuer.</p>
          <h3>1. Definitions</h3>
          <p>As used here, “you” and “your” mean each Account applicant; any person responsible for paying the Issuer; and any person responsible for complying with this Agreement. “We,” “us,” “our,” and “Issuer” mean card issuing Bank; and its agents, program managers, authorized representatives, successors, and assignees.</p>
          <p>
            <b>“Balance Transfer”</b>
             means a Transfer posted to the purchase segment of your Account, including another card on your Account.
          </p>
          <p>
            <b>“Billing Cycle”</b>
             means the period reflected on a Statement. This period may vary in length but is approximately 30 days. You will have a Billing Cycle even if a Statement is not required. We will often specify a Billing Cycle by the month in which its closing date occurs. For example, a “March Billing Cycle” will have a closing date in March. We may also refer to a Billing Cycle as a “Billing Period”.
          </p>
          <p>
            <b>“Card” </b>
             means any Debit Card associated with your Account. This includes all renewals and substitutions. It also means any other access device for your Account we give you that allows you to hold balances, including any Account number.
          </p>
          <p>
            <b>“Cash Advance”</b>
             means cash or things we consider cash equivalents, including wire transfers, travelers’ checks, money orders, or foreign currency.
          </p>
          <p>
            <b>“Fees”</b>
             means charges imposed on your Account not based on any Annual Interest Rates.
          </p>
          <p>
            <b>“Payment Card Network”</b>
             means the network provider displayed on your Card. This may be Visa International, MasterCard International, or any other network provider.
          </p>
          <p>
            <b>“Special Transfer”</b>
             means a Transfer posted to your Account that is not your purchase or Cash Advance.
          </p>
          <p>
            <b>“Statement”</b>
             means a document showing important Account information, including all transactions billed to your Account during a Billing Cycle. We may also refer to your Statement as a “Periodic Statement” or a “Billing Statement”.
          </p>
          <p>
            <b>“Transfers”</b>
             means amounts transferred from other accounts to this Account and includes Balance Transfers and Special Transfers.
          </p>
          <h3>2. Documents</h3>
          <p>The following documents govern your Account with us: (1) this Agreement; (2) all Statements; (3) any Rewards Program terms, conditions, and disclosures; (4) any privacy notices; (5) your Card benefits brochure which describes benefits provided by the Payment Card Network for your Account or other third parties; (6) all disclosures and materials provided to you before or when you opened your Account; (7) any other documents and disclosures relating to your Account, including those provided online; and (8) any future changes we make to any of the above. Please read these carefully and keep them for future reference.</p>
          <h3>3. New Offers in the Future</h3>
          <p>We may provide you with new offers that we think may interest you. The terms of these offers may differ from the standard terms on your Account. This Agreement will still apply.</p>
          <h3>4. Account Information</h3>
          <p>We need information about you to manage your Account. This includes (1) your legal name; (2) your valid residential address with acceptable proof dated no more than 90 days prior to the date of submitting your application; (3) your date of birth; (4) valid photo IDs or other valid government photo identification; (5) your mobile phone number; and (6) your email address. You must tell us when this information changes. We may ask you for additional documents to verify any changes. We may restrict or close your Account if we cannot verify your information, or if you do not provide it as requested.</p>
          <h3>5. Load Capacity / Available Balance</h3>
          <p>When you open your Account, we will tell you your Load Capacity. You may add funds to your Account at any time, but you may not exceed the Load Capacity. Your balance may not be available for all segments of your Account. For example, you may have one Available Balance for purchases and a different one for Cash Advances. You are responsible for keeping track of your Section balances and your available credit. We may honor transactions above your credit limits, but if we do these transactions will not increase your credit limit. You are responsible for paying for any transaction you make beyond your Available Balance. We may also increase, decrease, restrict, or cancel your credit limit on any Segment at any time. This will not affect your obligation to pay us. There may be a Security Deposit required to maintain your Account and your balances. If this is the case, we will advise you of the amount required, which may increase or decrease over time. If we require a security deposit, it will be returned to you not less than 180 after closing your account, either by You or by Us. Any fees which may be charged to your account may reduce the amount of the security deposit which is owed to you.</p>
          <h3>6. Security Deposit</h3>
          <h3>7. Using Your Account</h3>
          <p>(1) This Agreement applies whether you use your Card or Account or not. It will continue to apply even after your Account is closed, as long as you have a balance. </p>
          <p>(2) You must sign the Card immediately when you receive it. </p>
          <p>(3) You must return the Card to us or destroy it if we ask you to. </p>
          <p>(4) You must take reasonable steps to prevent the unauthorized use of your Card and Account.</p>
          <p>(5) We may decline to authorize a transaction for any reason. This may occur even if the transaction would not cause you to go beyond your spending limit or your Account is not in default.</p>
          <p>(6) We are not responsible for any losses you incur if we do not authorize a transaction. </p>
          <p>(7) We are not responsible for any losses you incur if anyone refuses to accept your Card for any reason.</p>
          <p>(8) You may obtain Cash Advances and Transfers as permitted for your Account. You are responsible for any fees charged by the ATM operator for obtaining cash through the ATM network. These fees may be in addition to fees we charge for accessing the ATM network.</p>
          <p>(9) You must not use, or try to use, the Card for any illegal activity. You are responsible for any charges if you do.</p>
          <p>(10) We are not liable for any losses that may result when our services are unavailable due to reasons beyond our control.</p>
          <h3>8. Using a PIN</h3>
          <p>As part of your card activation process you will need to set your personal identification number (PIN). For security reasons, you may have to provide the PIN before you are able to use your Card. Keep your PIN secure. Do not write it down, give it to anyone, or keep it with your Card. If you lose your Card or believe the confidentiality of your PIN has been compromised for any reason, you must reset the PIN immediately.</p>
          <h3>9. Your Promise to Pay</h3>
          <p>You promise to pay us all amounts due on your Account. This includes amounts where you did not sign a purchase slip or other documents for the transaction. We will treat transactions made without presenting your actual Card (such as for mail, telephone, Internet, or mobile device purchases) the same as if you used the Card in person. If you let someone else use your Card, you are responsible for all transactions that person makes.</p>
          <p>
            <b>Statements</b><br/>
            We may make available to you one Statement each for all Cards on your Account at the end of each Billing Cycle. Under certain circumstances, the law may not require us to send or make available to you a Statement or may prohibit us from doing so.
          </p>
          <p>
            <b>Disputed Transactions</b><br/>
            You must inspect each Statement you receive. Advise us about any errors or questions you have. If you do not notify us of an error, we will assume that all information on the Statement is correct. If we credit your Account for all or part of a disputed transaction, you give us all your rights against others regarding that transaction. You will also:
          </p>
          <p>(1) give us any information about the disputed transaction, if we ask;</p>
          <p>(2) not pursue any claim or reimbursement of the transaction amount from the merchant; or any other person; </p>
          <p>(3) help us get reimbursement from others.</p>
          <h3>10. No Warranties</h3>
          <p>We make no warranties of any kind, express or implied, with respect to your card, your account, or any related services. This includes, but is not limited to, warranties of merchantability or fitness for a particular purpose. We do not guarantee that your card will always be accepted by merchants or that your account will always be accessible or error-free. We are not responsible for any damages or losses that result from the use of your card or account, including but not limited to any direct, indirect, consequential, or incidental damages. You acknowledge and agree that your use of the card and account is at your own risk.</p>
          <h3>11. Lost or Stolen Card</h3>
          <p>If your Card is lost or stolen or if you think someone else may be using your Card or Account number without your permission, you must contact Customer Service immediately. You will not be responsible for transactions on your Account that we find are unauthorized, after the card is reported lost or stolen. If we reimburse you for unauthorized transactions, you will help us investigate, pursue, and get reimbursement from the wrongdoer. Your help includes giving us documents in a form that we request.</p>
          <h3>12. Fees</h3>
          <p>
            <b>Membership Fee</b><br/>
            If your Account has a membership Fee, we may charge the first membership Fee on the day you activate your Card, on the day of your first payment, or on the day when you use your Account, whichever occurs first. If it is an annual Fee, we may then charge it approximately once per year. If it is a monthly Fee, we may charge it each Billing Cycle.
          </p>
          <p>
            <b>Cash Advance Fee</b><br/>
            We may charge you this Fee each time you take out a Cash Advance. We will treat this Fee as a Cash Advance transaction.
          </p>
          <p>
            <b>Transfer Fee</b><br/>
            We may charge you this Fee each time you make a Transfer to another Member. Transactions Made in Foreign Currencies If you make a transaction in a foreign currency, the Payment Card Network will convert it into a U.S. Dollar amount. The Payment Card Network will use its own currency conversion procedures. The conversion rate in effect on the processing date may differ from the rate in effect on the transaction date that appears on your Statement. We may adjust the currency exchange rate or charge additional currency conversion Fees.
          </p>
          <h3>13. Making Payments</h3>
          <p>Your payment must be made in U.S. dollars, USDC or USDT in a form acceptable to us. You will be advised of the methods in which you may make payments to this account. We are not responsible if any financial institution rejects a payment made using our payment services. If you ask someone else to make a payment for you, we may provide that person with limited Account information necessary to set up and process that payment. We may also refuse to accept that payment. If we do accept it, you will be responsible for that payment even if a financial institution rejects it.</p>
          <h3>14. Payment Processing</h3>
          <p>We may accept and process payments without losing any of our rights. We may delay the availability of funds until we confirm that your payment has cleared and posted to your account. This may happen even if we credit your payment to your Account. We may collect returned payments from your account. If necessary, we may adjust your Account to correct errors, process returned and reversed payments, and handle similar issues.</p>
          <h3>15. Communications</h3>
          <p>You agree that we may communicate with you by mail, telephone, email, fax, pre-recorded message, automated voice, text message or other means allowed by law regarding your Account. You agree that we may contact you at any telephone number (including a mobile telephone number that you provide us) and use an automated telephone dialing system or similar device to do so. You agree that we may monitor or record any conversation or other communication with you.</p>
          <h3>16. Closing or Suspending Your Account</h3>
          <p>You may contact Customer Service to ask us to close your Account. We may close or suspend your Account at any time and for any reason permitted by law, even if you have not requested it. If we close or suspend your Account for any reason, you must stop using your Card. You must also cancel all billing arrangements set up on the Account. If we close or permanently suspend your Account, you must return or destroy all Cards. You must still pay us all amounts you owe on the Account.</p>
          <h3>17. Changes to Your Agreement</h3>
          <p>At any time, we may add, delete, or change any term of this Agreement, unless the law prohibits us from doing so. We will give you notice of any changes as required by law. We may notify you of changes on your Statement or in a separate notice. Our notice will tell you when and how the changes will take effect. The notice will describe any rights you have in connection with the changes. If we change your Fees or other terms of your Account, we will notify you as required by law.</p>
          <h3>18. The Law That Applies to Your Agreement</h3>
          <p>The validity, construction and interpretation of this Agreement and the rights and duties of the Parties hereto shall be governed by the laws of Panama, without regard to choice of law and conflict of law principles. The Parties submit to the exclusive jurisdiction of the Courts of Panama for the resolution of any dispute, difference, controversy, or claim arising out of or relating to this Agreement. If any part of this Agreement is unenforceable, the remaining parts will remain in effect.</p>
          <h3>19. Waiver</h3>
          <p>We will not lose any of our rights if we delay or choose not to take any action for any reason. We may waive our right without notifying you. For example, we may waive your Fees without notifying you and without losing our right to charge them in the future.</p>
          <h3>20. Assignment</h3>
          <p>This Agreement will be binding on, and benefit, any of your and our successors and assigns. You may not sell, assign or transfer your Account or this Agreement to someone else without our written permission. We may sell, assign or transfer your Account and this Agreement without your permission and without prior notice to you. Any assignee or assignees will take our place under this Agreement. You must pay them and perform all your obligations to them and not us. If you pay us after we notify you that we have transferred your Account or this Agreement, we can return the payment to you, forward the payment to the assignee, or handle it in another way that is reasonable.</p>

        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <template v-if="protocol_status==1">
          <el-button v-if="is_bottom" @click="p_status_dlg_confirm" class="confirm_btn2">
            {{$t('beth_text.read_agree')}}
          </el-button>
          <el-popover
            v-else
            placement="top"
            trigger="hover"
            :content="$t('v_life.read_content')">
            <el-button slot="reference" class="confirm_btn2_no">{{$t('beth_text.read_agree')}}</el-button>
          </el-popover>
        </template>      
      </span>
    </el-dialog>

  </div>
</template>

<script>
import loadFreshchat from "@/utils/loadFreshchat";
import {getUserInfo,exitLogin,count,modifyProtocolStatus} from '@/api/api';
export default {
  data() {
    return {
      pc_app: this.pcormove._isMobile(),
      head_title:'',
      visible:false,
      visible_lan:false,
      user_img_url:'',
      log_out_dlg:false,
      kyc_step_btn:false,
      service_dlg:false,
      kyc_icon_ok:false,
      return_sup:false,
      head_title2:'',
      apply_card_info_return:false,
      system_status:"",// 公告 有无未读 0没有 1有
      msg_status:"",// 消息 有无未读 0没有 1有
      dot_hidden:true,
      protocol_status:0,//协议 1打开 0关闭
      protocol_status_dlg:false,
      is_bottom:false,
    }
  },
  mounted() {
    this.set_active();
    this.get_user_info();
    this.get_count();
    this.bus.$on("user_data",(v)=>{
      v;
      // console.log(v);
      this.get_user_info();
    });
    this.bus.$on('kf_dlg',()=>{
      this.service_dlg=true;
      // console.log(111);
    });
    this.head_title2=sessionStorage.getItem('top_title_name')?sessionStorage.getItem('top_title_name'):'';
    this.bus.$on('open_logout_dlg', v => {
      this.log_out_dlg=v;
    })
    this.bus.$on("request_unread_num",res=>{
      if (res) {
        this.get_count();
      }
    })
    this.bus.$on('open_agreement',res=>{
      if(res){
        this.protocol_status_dlg=true;
      }
    });

  },
  destroyed() {
    this.bus.$off("user_data");
    this.bus.$off('kf_dlg');
    this.bus.$off('open_logout_dlg');
    this.bus.$off('request_unread_num');
    this.bus.$off('open_agreement');
  },
  methods:{
    set_active(){
      if(this.$route.path=='/'){
        this.head_title = this.$t('main.text12');
        this.kyc_step_btn=false;
        this.kyc_icon_ok=false;
      }else if(this.$route.path=='/my_transaction'){
        this.head_title = this.$t('main.text746');
        this.kyc_step_btn=false;
        this.kyc_icon_ok=false;
      }else if(this.$route.path=='/blockchain_d'){
        this.head_title = this.$t('main.text14');
        this.kyc_step_btn=false;
        this.kyc_icon_ok=false;
      }else if(this.$route.path=='/blockchain_w'){
        this.head_title = this.$t('main.text15');
        this.kyc_step_btn=false;
        this.kyc_icon_ok=false;
      }else if(this.$route.path=='/fiat_deposit'){
        this.head_title = this.$t('main.text16');
        this.kyc_step_btn=false;
        this.kyc_icon_ok=false;
      }else if(this.$route.path=='/fiat_withdrawal'){
        this.head_title = this.$t('main.text17');
        this.kyc_step_btn=false;
        this.kyc_icon_ok=false;
      }else if(this.$route.path=='/otc'){
        this.head_title = this.$t('main.text18');
        this.kyc_step_btn=false;
        this.kyc_icon_ok=false;
      }else if(this.$route.path=='/fx'){
        this.head_title = this.$t('main.text19');
        this.kyc_step_btn=false;
        this.kyc_icon_ok=false;
      }else if(this.$route.path=='/kyc'){
        this.head_title = this.$t('main.text241');
        this.kyc_step_btn=false;
        this.kyc_icon_ok=true;
      }else if(this.$route.path=='/kyc_step/kyc_step_one'){
        this.head_title = this.$t('main.text21');
        this.kyc_step_btn=true;
        this.kyc_icon_ok=false;
      }else if(this.$route.path=='/kyc_step/kyc_step_two'){
        this.head_title = this.$t('main.text22');
        this.kyc_step_btn=true;
        this.kyc_icon_ok=false;
      }else if(this.$route.path=='/kyc_step/kyc_step_three'){
        this.head_title = this.$t('main.text23');
        this.kyc_step_btn=true;
        this.kyc_icon_ok=false;
      }else if(this.$route.path=='/kyc_step/kyc_step_four'){
        this.head_title = this.$t('main.text24');
        this.kyc_step_btn=true;
        this.kyc_icon_ok=false;
      }else if(this.$route.path=='/private_b_p'){
        this.head_title = this.$t('main.text267');
        this.kyc_step_btn=false;
        this.kyc_icon_ok=false;
      }else if(this.$route.path=='/structured_p'){
        this.head_title = this.$t('main.text268');
        this.kyc_step_btn=false;
        this.kyc_icon_ok=false;
      }else if(this.$route.path=='/investment_b'){
        this.head_title = this.$t('main.text269');
        this.kyc_step_btn=false;
        this.kyc_icon_ok=false;
      }else{
        this.head_title = '';
        this.kyc_step_btn=false;
        this.kyc_icon_ok=false;
      }

      if(
        this.$route.path.indexOf('transaction_h_info')!=-1||
        this.$route.path.indexOf('m_m_payee_list')!=-1||
        this.$route.path.indexOf('new_fiat')!=-1||
        this.$route.path.indexOf('new_fiat2')!=-1||
        this.$route.path.indexOf('m_m_addr_list')!=-1||
        this.$route.path.indexOf('new_digital_asset')!=-1||
        this.$route.path.indexOf('new_digital_asset2')!=-1||
        this.$route.path.indexOf('fiat_t_h_info')!=-1||
        this.$route.path.indexOf('my_transaction_info')!=-1||
        this.$route.path.indexOf('digital_t_h_info')!=-1||
        this.$route.path.indexOf('apply_card_input')!=-1||
        this.$route.path.indexOf('top_up_history')!=-1||
        this.$route.path.indexOf('transaction_record')!=-1||
        this.$route.path.indexOf('renew')!=-1||
        this.$route.path.indexOf('bank_details')!=-1
      ){
        this.return_sup=true;
      }else{
        this.return_sup=false;
      }

      if(this.$route.path.indexOf('apply_card_info')!=-1){
        this.apply_card_info_return=true;
      }else{
        this.apply_card_info_return=false;
      }

    },
    router_fun(){
      if (this.$router.currentRoute.path!='/user_info') {
        this.$router.push('/user_info');
      }
      this.visible=false;
    },
    router_kyc(){
      if (this.$router.currentRoute.path!='/kyc') {
        this.$router.push('/kyc');
      }
      this.visible=false;
    },
    get_user_info(){
      getUserInfo().then(res=>{
        if (res.data.code==200) {
          this.user_img_url=res.data.data.avatar;
          localStorage.setItem('approve_status',res.data.data.approve_status);
          // 头像

          // kyc_status: KYC状态 0没有 1保存未提交 2 待审核   3一审通过  4审核通过  5审核失败
          // 4审核通过 路由才能跳转
          // sessionStorage.setItem("kyc_status", res.data.data.kyc_status);
          //邮箱
          sessionStorage.setItem("u_email", res.data.data.email);

          const username = res.data.data.username;
          const email = res.data.data.email;
          const userid = res.data.data.userid;
          this.$store.dispatch("set_name",username);
          this.$store.dispatch("set_email",email);
          this.$store.dispatch("set_userid",userid);
          if(username&&email&&userid){
            const that = this;
            loadFreshchat(() => {
              that.$store.dispatch("set_freshchatLoaded",true);
            });
          }
          // 协议 1打开 0关闭
          this.protocol_status = res.data.data.protocol_status;
          if(this.protocol_status==1){
            this.protocol_status_dlg=true;
          }else{
            this.protocol_status_dlg=false;
          }
        }
      })
    },
    log_out_li(){
      this.log_out_dlg=true;
      this.visible=false;
    },
    log_out_btn(){
      exitLogin().then(res=>{
        if(res.data.code==200){
          localStorage.clear();
          sessionStorage.clear();

          this.$store.state.login.router_true=true;
          this.$router.push("/login");

        }
      })
      
    },
    open_view_profile(){
      this.visible=false;
      if (this.$router.currentRoute.path!='/user_info') {
        this.$router.push('/user_info');
        setTimeout(() => {
          this.bus.$emit('open_view_profile_dlg');
        }, 100);
      }else{
        this.bus.$emit('open_view_profile_dlg');
      }
    },
    open_change_password(){
      this.visible=false;
      if (this.$router.currentRoute.path!='/user_info') {
        this.$router.push('/user_info');
        setTimeout(() => {
          this.bus.$emit('open_change_password_dlg');
        }, 100);
      }else{
        this.bus.$emit('open_change_password_dlg');
      }
    },
    open_sidebar(){
      this.bus.$emit('app_sidebar_open');
    },
    lang_fun(v) {
      localStorage.setItem("language", v);
      setTimeout(() => {
        location.reload();
      }, 100);
    },
    info_return(){
      this.bus.$emit("info_return_fun");
    },
    async get_count(){
      const res = await count();
      if(res.data.code!=200){
        return this.message.ismessage('error',res.data.msg);
      }
      // system_status: 公告 有无未读 0没有 1有
      // msg_status: 消息 有无未读 0没有 1有
      this.system_status = res.data.data.system_status;
      this.msg_status = res.data.data.msg_status;
      if(this.system_status==1 || this.msg_status==1){
        this.dot_hidden = false;
      }else{
        this.dot_hidden = true;
      }
      
    },
    to_affiche(){
      if(this.msg_status){
        if (this.$router.currentRoute.path!='/affiche/affiche_list') {
          this.$router.push('/affiche/affiche_list');
        }
      }else if(this.system_status){
        if (this.$router.currentRoute.path!='/affiche/affiche_list_admin') {
          this.$router.push('/affiche/affiche_list_admin');
        }
      }else{
        if (this.$router.currentRoute.path!='/affiche/affiche_list') {
          this.$router.push('/affiche/affiche_list');
        }
      }
    
    },
    scroll(e) {
      const { scrollTop, clientHeight, scrollHeight } = e.target;
      if (scrollTop + clientHeight >= (scrollHeight - 30)) {
        this.is_bottom = true;
      }
    },
    async p_status_dlg_confirm(){
      const res = await modifyProtocolStatus({})
      if(res.data.code!=200){
        return this.message.ismessage('error',res.data.msg);
      }
      this.protocol_status_dlg=false;
      this.get_user_info();
    }
    
  },
  watch:{
    $route(){
      this.set_active();
      this.get_count();
      setTimeout(() => {
        this.head_title2=sessionStorage.getItem('top_title_name')?sessionStorage.getItem('top_title_name'):'';
      }, 0);
    }
  }

}
</script>

<style scoped>
.header{
  height: 80px;
  background: #191E29;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 40px;
}
.top_tit{
  font-style: normal;
  font-weight: bold;
  /* font-size: 28px; */
  font-size: 24px;
  /* line-height: 26px; */
  height: 100%;
  display: flex;
  align-items: center;
  max-width: 80%;
}
.user_img img{
  width: 45px;
  height: 45px;
  border-radius: 50%;
  cursor: pointer;
  margin-top: -5px;
}
.u_box ui,
.u_box li{
  list-style: none;
  cursor: pointer;
}
.u_box .u_operation{
  border-bottom: 1px solid #313131;
  padding-bottom: 10px;
}
.u_box li{
  box-sizing: border-box;
  padding: 10px 5px;
}
.u_box li img{
  width: 20px;
  vertical-align: middle;
  margin-right: 10px;
}

/* ------ */
.dlg_body{
    background: #041E35;
    color: #fff;  
}
.d_body{
    box-sizing: border-box;
    padding: 40px 0;
    max-width: 420px;
    margin: auto;
}
.dlg_u_box{
    display: flex;
    align-items: center;
}
.dlg_u1{
    width: 100px;
    height: 100px;
    border: 2px solid #DEB981;
    border-radius: 50%;
}
.dlg_u2,.dlg_u2:hover{
    background: linear-gradient(90deg, #F1C788 0.42%, #E3A84E 100.42%);
    box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
    border: none;
    border-radius: 4px;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 18px;
    color: #04182A;
    margin-left: 40px;
    margin-bottom: 8px;
}
.dlg_u3{
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 18px;
    color: #FFFFFF;
    margin-left: 40px;
}
.dlg_form{
    margin-top: 25px;
}
.dlg_form >>> .el-form-item__label{
    line-height: 30px;
    color: #fff;
    padding: 0;
}
.cancel_btn{
    color: #BBBBBB;
    border-color: #BBBBBB;
    background: transparent;
}
.confirm_btn{
  /* width: 130px; */
  background: #FF6363;
  border-color: #FF6363;
  border-radius: 4px;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  color: #191E29;
  margin-left: 20px;
  margin-bottom: 15px;
}
.confirm_btn2{
  min-width: 86px;
  background: #00C18E;
  box-shadow: 0px 2px 4px rgba(222, 185, 129, 0.2);
  border-color: #00C18E;
  border-radius: 4px;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  color: #04182a;
  margin-bottom: 15px;
}
.confirm_btn2_no{
  min-width: 86px;
  background: #dbdbdb;
  border-color: #dbdbdb;
  border-radius: 4px;
  font-style: normal;
  font-weight: bold;
  font-size: 15px;
  color: #04182a;
  margin-bottom: 15px;
  cursor: no-drop;
}
/* .padding1{
  padding: 0 30px;
}
.padding2{
  padding: 0 27px;
} */
/* --- */
.out_box{
  text-align: center;
  font-size: 20px;
}
/* 退出弹框 */
.log_out1 img{
  width: 40px;
  display: block;
  margin: auto;
}
.log_out2{
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  color: #FFFFFF;
  margin-top: 16px;
  text-align: center;
  word-break: break-word;
  word-wrap: break-word;
}
.log_out3{
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 22px;
  text-align: center;
  color: #FFFFFF;
  opacity: 0.8;
  margin-top: 8px;
  text-align: center;
  word-break: break-word;
  word-wrap: break-word;
}
.u_r_icon{
  margin-left: 10px;
  margin-top: -30px;
  cursor: pointer;
  vertical-align: middle;
}

.li_log_out{
  margin-top: 15px;
}
.app_sidebar_btn{
  display: none;
}

/* --over-- */
.top_right_box{
  display: flex;
}
.lan_icon{
  width: 28px;
  height: 28px;
  vertical-align: middle;
  cursor: pointer;
  color: #00C18E;
}
.top_right_box1{
  /* margin-right: 30px; */
  display: flex;
  align-items: center;
}
.u_r_icon2{
  margin-left: 8px;
  cursor: pointer;
  margin-top: 5px;
  color: #00C18E;
}
.lan_list_item{
  cursor: pointer;
  /* width: 28px;
  height: 28px; */
  margin: 10px auto;
  display: block;
}
.head_title2{
  /* max-width: 70%; */
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}

.affiche_btn{
  margin-top: 8px;
  margin-right: 15px;
}
.affiche_btn i{
  font-size: 20px;
  cursor: pointer;
}
.affiche_btn >>> .el-badge__content{
  border: none;
}
</style>

<style>
.top_user{
  color: #fff;
  font-size: 15px;
  background: #03101C;
  box-shadow: 0px 4px 8px #03101C;
  border-radius: 16px;
  border: none;
}
.top_user[x-placement^=bottom] .popper__arrow,
.top_user[x-placement^=bottom] .popper__arrow::after{
  display: none;
  border-bottom-color: transparent;
}
.top_user .popper__arrow{
  display: none;
}
.lan_popover{
  min-width: 70px;
  transform: translateX(-3px);
}
/* ---- */
/* .dlg{
    background:rgb(4, 23, 40) !important;
    color: #fff;
} */
.dlg .el-dialog__title{
    color: #fff;
}
.dlg .el-dialog__headerbtn{
  left: auto;
}
.dlg .el-dialog__headerbtn .el-dialog__close{
    color: #fff;
}
.dlg .el-dialog__body {
    padding: 30px 0;
}
.back_icon i{
  font-size: 20px;
  color: #fff;
  margin-right: 10px;
  cursor: pointer;
}

/* 退出 弹框 */
.log_out_dlg_bgc{
  background: #232A36 !important;
  color: #fff;
  border-radius: 16px;
}
.log_out_dlg_bgc .el-dialog__header{
  padding: 0 !important;
}
/* ---over--- */
.log_out_color{
  color: #FF4646;
}
/* 协议2023-10-26 */
.dlg_agreement{
  padding: 25px;
  color: #d9d9d9;
  overflow-y: auto;
  max-height: 65vh;
  box-sizing: border-box;
}
.dlg_agreement b{
  color: #fff;
}
.dlg_agreement p,
.dlg_agreement h3{
  padding-bottom: 10px;
  word-break: break-word;
}
.dlg_agreement::-webkit-scrollbar {
  width: 5px;
}
.dlg_agreement::-webkit-scrollbar-thumb {
  border-radius: 5px;
  background: #00C18E;
}
</style>

<style scoped>
  /* 手机端 */
@media screen and (max-width: 850px) {
  .header{
    padding: 0 15px;
  }
  .app_sidebar_btn{
    display: inline-block;
    font-size: 20px;
    margin-left: 10px;
  }
  .top_tit{
    flex: auto;
    padding-left: 10px;
    font-size: 18px;
  }
  .head_width{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }



}

</style>

<style>
  /* #fc_frame, #fc_frame.fc-widget-normal {
    width: 97% !important;
    z-index: 999999999999999999999999999999999999999 !important;
  } */
  /* .multi-widget-ui.fc-widget-left .hotline-launcher.h-open {
    left: inherit !important;
    right: 0px !important;
    z-index: 999999999999999999999999999999999999999 !important;
  }
  .fc-widget-left .d-hotline.h-btn {
    left: inherit !important;
    right: 20px !important;
    z-index: 999999999999999999999999999999999999999 !important;
  } */
</style>

